import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 23667 30877"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970281363072">
        <path
          d="M23667 14615c0 340-149 677-436 904-500 396-1225 313-1621-186L11834 3009 2057 15333c-396 499-1121 582-1620 186-500-396-583-1120-187-1620L10930 436c218-275 552-436 904-436 351 0 685 161 903 436l10680 13463c169 212 250 465 250 716z"
          className="fil0"
        />
        <path
          d="M23667 22169c0 340-149 676-436 904-500 396-1225 313-1621-187l-9776-12323-9777 12323c-396 499-1121 583-1620 187-500-396-583-1122-187-1620L10930 7990c218-276 552-437 904-437 351 0 685 161 903 437l10680 13463c169 212 250 465 250 716z"
          className="fil0"
        />
        <path
          d="M23667 29723c0 340-149 676-436 904-500 396-1225 313-1621-187l-9776-12323-9777 12323c-396 499-1121 583-1620 187-500-396-583-1121-187-1620l10680-13463c218-276 552-437 904-437 351 0 685 162 903 437l10680 13463c169 212 250 464 250 716z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
